




































import { Component, Vue, Prop } from "vue-property-decorator";
import ProgressBarCircle from "@/components/ProgressBar/ProgressBarCircle.vue";
import ProgressBarLinear from "@/components/ProgressBar/ProgressBarLinear.vue";
import YoutubeLogo from "@/assets/unterricht/YouTube_desktop_white.svg";

@Component({
  components: { ProgressBarLinear, ProgressBarCircle },
})
export default class DashboardUpcoming extends Vue {
  public name = "UnterrichtDashboardCover";
  public YoutubeLogo = YoutubeLogo;

  @Prop({ default: () => "" })
  public youtubeLink!: string;
}
